module.exports = __webpack_public_path__ + "static/004-slideshow-b69998adb146bf58eda99e058117cee7.jpg";